import { APP_CONFIG } from '@/config/app';

/**
 * Format a number as currency
 */
export function formatCurrency(
  amount: number | null | undefined,
  options: {
    locale?: string;
    currency?: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  } = {}
): string {
  if (amount == null || isNaN(amount)) return '$0';

  const {
    locale = APP_CONFIG.currency.locale,
    currency = APP_CONFIG.currency.default,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2,
  } = options;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount);
}

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  UZS: 'UZS',
};

/**
 * The label to print next to an amount, derived from the contract's own currency.
 *
 * Reports previously hardcoded `currency === 'UZS' ? 'UZS' : '$'`, which prints a
 * dollar sign for every non-UZS contract and for any view where the contract has
 * not loaded yet. Deriving it from the value keeps unknown currencies honest —
 * an unrecognised code prints itself rather than being relabelled as dollars.
 * Defect report AL-2026/08-03-01, R-07.1.
 */
export function currencyLabel(currency?: string | null): string {
  if (!currency) return '';
  return CURRENCY_SYMBOLS[currency] ?? currency;
}

